'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = require('draft-js');

exports.default = function (text) {
  return _draftJs.EditorState.createWithContent(_draftJs.ContentState.createFromText(text));
}; /**
    * Create an editor state with some text in it already
    */


//////////////////
// WEBPACK FOOTER
// ./~/draft-js-plugins-editor/lib/utils/createEditorStateWithText.js
// module id = 733
// module chunks = 0